import React from 'react'
import { Autocomplete, TextField } from '@mui/material'
import { useGetSalesIds } from '../../api/sales'

export const SalesFilter = ({ setSalesIds, salesIds, htgCompany = '' }) => {
  const { data = [], isLoading } = useGetSalesIds({ htgCompany })

  return (
    <Autocomplete
      multiple={true}
      options={data}
      onChange={(event, value) => setSalesIds(value)}
      size='small'
      fullWidth
      renderInput={(params) => <TextField {...params} label='Sales Ids' />}
      value={salesIds}
      disabled={isLoading}
      loading={isLoading}
      autoHighlight={true}
    />
  )
}
